import { MainTitle } from 'common/text';
import BackButton from 'common/buttons/back';
import { Content } from 'common/containers';
import EditOrderForm from 'components/forms/orders/edit';
import useFetchData from 'hooks/useFetchData';
import Skeleton from 'common/skeleton';
import { useParams } from 'react-router-dom';
const ProductEdit = () => {
	const { id } = useParams<{ id: string }>();
	const { response, isLoading } = useFetchData(`orders/${id}`);
	return (
		<>
			<MainTitle>
				<h1>Editar orden</h1>
				<BackButton />
			</MainTitle>
			<Content>
				{isLoading && <Skeleton count={10} />}
				{!isLoading && (
					<EditOrderForm
						data={response}
						id={id}
					/>
				)}
			</Content>
		</>
	);
};
export default ProductEdit;
